<template>
  <div>
    <el-carousel :height="bannerHeight+'px'">
      <el-carousel-item v-for="(item, index) in bannerUrl" :key="index">
        <img v-if="item.linkUrl"
          ref="imgHeight"
          :src="item.value"
             style="cursor: pointer"
          alt=""
           @load="imgLoad"
          @click="onLink(item.linkUrl)"
        />
        <img else
          ref="imgHeight"
          :src="item.value"
          alt=""
           @load="imgLoad"
        />
        <el-button class="banner_video" v-if="item.videoUrl" @click="onClickVideo(item.videoUrl)">查看视频</el-button>
        <slot name="dataMesg"></slot>
      </el-carousel-item>
    </el-carousel>
    <!-- 点击查看视频 -->
    <VideoDialog ref="videoDialogRef" />
  </div>
</template>

<script>
import VideoDialog from "../VideoDialog/index";
export default {
  components: {
    VideoDialog
  },
  props: {
    bannerUrl: Array,
  },
  data() {
    return {
      bannerHeight: "",
      imgHeightsetIn: null,
    };
  },
  watch: {
    bannerUrl(newValue ,oldValue) {
      this.imgLoad();
    },
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        this.imgLoad();
      },
      false
    );
  },
  methods: {
    onLink(linkUrl) {
      if (linkUrl) {
        window.open(linkUrl, "_blank");
      }
    },
    // 点击查看视频
    onClickVideo(url) {
      this.$refs.videoDialogRef.init(url)
    },
    imgLoad() {
      this.imgHeightsetIn = setInterval(() => {
        let ref = this.$refs;
        this.bannerHeight =
          ref.imgHeight && ref.imgHeight.length ? ref.imgHeight[0].height : "";
        clearInterval(this.imgHeightsetIn);
      }, 520);
    },
  },
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
}
.banner_video {
  position: absolute;
  bottom: 14%;
  left: 50%;
  transform: translate(-50%, 0);
  background: transparent;
  color: #fff;
  &:hover {
    color: #099;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/carousel.vue